import { regexCustomerID, regexTaxNumber } from "utils/regex";
import { TCheckoutContext } from "./types";

export const guards = {
  checkEmptyFields: (ctx: TCheckoutContext) => {
    if (
      ctx.params.CustomerID.trim().length > 0 &&
      ctx.params.TaxNumber.trim().length > 0 &&
      ctx.params.CustomerID !== "null" &&
      ctx.params.TaxNumber !== "null"
    ) {
      return false;
    }
    return true;
  },
  checkFormat: (ctx) => {
    const customerIdMatch = regexCustomerID.test(ctx.params.CustomerID);
    const taxNumberMatch = regexTaxNumber.test(ctx.params.TaxNumber);
    return !(customerIdMatch && taxNumberMatch);
  },
  checkGolink: (ctx: TCheckoutContext) => {
    return ctx?.paymentInfo?.data?.trim().length > 0;
  },
  checkGolinkFailure: (ctx: TCheckoutContext) => {
    return ctx?.paymentInfo?.data?.trim().length <= 0;
  },
  checkPaymentUrlExpire: (ctx, e: { data: string }) => {
    return e.data === null;
  },
  checkMaxInvoices: (ctx: TCheckoutContext, e: { invoice_number: string }) => {
    const selecteds = ctx.orders.filter((order) => order.selected);
    if (selecteds.findIndex((selected) => selected.invoice_number === e.invoice_number) > -1) {
      return false;
    }
    return (ctx.max_invoices <= selecteds.length);
  },
  checkSelectAllMaxInvoices: (ctx: TCheckoutContext) => {
    return (ctx.max_invoices <= ctx.orders.filter((order) => order.remaining_amount > 0).length);
  },
};
